export const isAuthenticated = ({ Session: { authenticated } }) => authenticated;
export const isLoading = ({ Session: { loading } }) => loading;
